<h3 class="timeline-container__header">ADDRESS TIMELINE</h3>
<app-timeline [timelineItems]="timelineItems"></app-timeline>
<div class="showall-timeline">
    <a [href]="showTimelineDetails()">See All</a>
</div>